define('home/models/SettingsProfile',[
    'underscore',

    'core/config',

    'home/models/common/BaseSettings',
    'home/models/User',
    'core/UniqueModel',
], function (
    _,

    config,

    BaseSettings,
    User,
    UniqueModel
) {
    'use strict';

    var SettingsProfile = BaseSettings.extend({
        url: config.urls.apiSettings + 'profile/',

        useMultiPartForm: true,

        initialize: function () {
            var userAttrs = {};
            userAttrs[User.prototype.idAttribute] = this.id;
            this.user = new UniqueModel(User, userAttrs);
            this.listenTo(this, 'change', this.updateUser);
        },

        save: function (attrs, options) {
            if (!attrs) {
                // Only send necessary attributes to api
                // (attrs like remote and avatar_permalink are unnecessary)
                attrs = _.pick(this.attributes, [
                    'display_name',
                    'about',
                    'location',
                    'url',
                    'is_private',
                    'avatar_file',
                    'avatar_source',
                    'avatar_facebook',
                    'avatar_twitter',
                ]);
            }

            return BaseSettings.prototype.save.call(this, attrs, options);
        },

        /**
         * Keeps user model up to date with values updated through the settings form,
         * which are stored and updated here.
         */
        updateUser: function () {
            var avatar = _.defaults({
                cache: this.get('avatar_cache'),
                permalink: this.get('avatar_permalink'),

                // TODO: Once the backend returns is_custom from the users/self/profile endpoint
                // we'll be able to use that and not compute it here in this hacky way.
                // Note this only works for users either created or with avatars edited after
                // http://phabricator.local.disqus.net/D19519, since before that fix the default
                // avatar was copied and renamed and wouldn't match /noavatar/.
                // https://trello.com/c/dRIfjJPj/350-add-avatar-is-custom-to-users-self-profile-endpoint-response
                isCustom: !/noavatar/.test(this.get('avatar_cache')),
            }, this.user.get('avatar'));

            this.user.set({
                about: this.get('about'),
                avatar: avatar,
                name: this.get('display_name'),
                isPrivate: this.get('is_private'),
                location: this.get('location'),
                url: this.get('url'),
            });
        },
    });

    UniqueModel.addType('SettingsProfile', SettingsProfile);

    return SettingsProfile;
});

